import { Box, Divider } from '@mui/material';
import { memo, ReactElement } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import { AttributesTooltip } from './AttributesColumn';
import { PredictionColumnCardLayout } from './PredictionColumnCardLayout';
import { MaterialTooltip } from './MaterialColumn';
import { useNavigate } from 'react-router-dom';

export interface PredictionColumnsLayoutProps {
  materialTypeColumn: ReactElement;
  attributesColumn: ReactElement;
  billableMaterialColumn?: ReactElement;
}

export const PredictionColumnsLayout = memo(function ({
  materialTypeColumn,
  attributesColumn,
  billableMaterialColumn,
}: PredictionColumnsLayoutProps): ReactElement {
  const navigate = useNavigate();

  const handleBillableMaterials = () => {
    navigate('/billable-materials');
  };

  return (
    <Box
      display='flex'
      height='100%'
      boxSizing='border-box'
      gap={1}
      padding={1}
      flex={1}
      sx={{ minWidth: 0, minHeight: 0 }}
    >
      <PredictionColumnCardLayout title={'material.title'} adornment={<MaterialTooltip />}>
        {materialTypeColumn}
      </PredictionColumnCardLayout>

      <Divider orientation='vertical' flexItem />

      <PredictionColumnCardLayout title={'attributes.title'} adornment={<AttributesTooltip />}>
        {attributesColumn}
      </PredictionColumnCardLayout>

      {billableMaterialColumn && (
        <>
          <Divider orientation='vertical' flexItem />

          <PredictionColumnCardLayout
            title={'billableMaterial.title'}
            adornment={<SettingsIcon onClick={handleBillableMaterials} sx={{ cursor: 'pointer' }} />}
          >
            {billableMaterialColumn}
          </PredictionColumnCardLayout>
        </>
      )}
    </Box>
  );
});
